module.exports = __webpack_public_path__ + "img/dianchi-80.f97c6f8d.png";